import { bind } from '@react-rxjs/core';
import { driver$ } from './driver';
import { catchError, map, of, shareReplay, switchMap } from 'rxjs';
import { vehicle$ } from './vehicle';
import { request } from './request';

export const [useFeatures, features$] = bind(
  driver$.pipe(map((driver) => (driver?.features ? driver.features : [])))
);
export const [useIsFeatureEnabled, isFeatureEnabled$] = bind(
  (feature: string) =>
    features$.pipe(map((features) => features.includes(feature)))
);

export const [useObjectFeatures, objectFeatures$] = bind(
  vehicle$.pipe(
    switchMap((vehicle) =>
      vehicle
        ? request<string[]>(
            `/gateway/access-control-service/v20240130/access-control/object/${vehicle.id}/features`
          ).pipe(catchError(() => of(null)))
        : of(null)
    ),
    shareReplay({ refCount: true, bufferSize: 1 })
  )
);
export const [useIsFeatureEnabledInObject, isFeatureEnabledInObject$] = bind(
  (feature: string) =>
    objectFeatures$.pipe(
      map((features) => features?.includes(feature) ?? false)
    )
);
